import React from 'react'

import { QuickSearch } from "./index.jsx"
import { ProductListItem } from './product';

const ProductSearch = ({ onSelect }) => {
  const suggestion = ({ suggestion: product  }) => (
    <ProductListItem product={product} isQuickSearch={true} />
  );

  return (
    <QuickSearch
      Suggestion={suggestion}
      className="products"
      placeholder="Search for the product here"
      url="/api/products/search"
      onSelect={onSelect}
      getValue={suggestion => suggestion.values_name}
    />
  );
}

export default ProductSearch;
